export const LD_INIT = 'LD_INIT';
export const LD_INIT_FAIL = 'LD_INIT_FAIL';
export const LD_INIT_SUCCESS = 'LD_INIT_SUCCESS';

export function initialize() {
    return {
        type: LD_INIT,
    };
}
